import React from 'react';
import { motion } from 'framer-motion';
import { X, AlertTriangle, Zap } from 'lucide-react';
const problems = [{
  icon: X,
  color: 'text-red-400',
  bg: 'bg-red-400/10 border-red-400/20',
  title: '"Cierra la puerta y déjalo llorar"',
  body: 'Tu instinto te dice que eso está mal — y tiene razón. No necesitas ignorar a tu hijo para que duerma.'
}, {
  icon: AlertTriangle,
  color: 'text-amber-400',
  bg: 'bg-amber-400/10 border-amber-400/20',
  title: '"Ya pasará con el tiempo"',
  body: 'Mientras tú sientes que te desmoronas hoy mismo. El tiempo sin un método solo prolonga el agotamiento.'
}, {
  icon: Zap,
  color: 'text-gold-300',
  bg: 'bg-gold-500/10 border-gold-500/20',
  title: 'El verdadero enemigo: El Cortisol',
  body: 'Cuando un bebé supera su ventana biológica de vigilia, su cerebro activa la hormona del estrés — y eso lo hace luchar contra el sueño.'
}];
export function ProblemSection() {
  return <section className="relative bg-navy-900 py-20 px-4" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-172">
          <p className="font-lato text-gold-400 text-sm font-bold tracking-widest uppercase mb-3" data-id="element-173">
            El Problema
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-cream leading-tight" data-id="element-174">
            La Mentira de{' '}
            <span className="gold-gradient-text" data-id="element-175">"Dejarlo Llorar"</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-14" data-id="element-176">
          {problems.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.15
          }} className={`navy-card rounded-2xl p-7 border ${item.bg}`} data-id="element-177">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-5 ${item.bg} border`} data-id="element-178">
                  <Icon size={22} className={item.color} data-id="element-179" />
                </div>
                <h3 className="font-playfair text-lg font-bold text-cream mb-3" data-id="element-180">
                  {item.title}
                </h3>
                <p className="font-lato text-cream/70 leading-relaxed text-sm" data-id="element-181">
                  {item.body}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="text-center" data-id="element-182">
          <p className="font-playfair text-2xl md:text-3xl font-bold text-cream" data-id="element-183">
            El problema no es tu bebé,{' '}
            <span className="gold-gradient-text" data-id="element-184">ni tu falta de instinto.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}